export const REGISTRATION_STATUS = Object.freeze({
  PENDING: 1,
  SHORTLISTED: 2,
  UN_SHORTLISTED: 3,
  EXHIBITOR_PENDING: 4,
  EXHIBITOR_IN_REVIEW: 5,
  EXHIBITOR_APPROVED: 6,
});

const STATUS_KEY_BY_ID = Object.freeze({
  [REGISTRATION_STATUS.PENDING]: "pending",
  [REGISTRATION_STATUS.SHORTLISTED]: "shortlist",
  [REGISTRATION_STATUS.UN_SHORTLISTED]: "un_shortlist",
  [REGISTRATION_STATUS.EXHIBITOR_PENDING]: "exhibitor_pending",
  [REGISTRATION_STATUS.EXHIBITOR_IN_REVIEW]: "exhibitor_in_review",
  [REGISTRATION_STATUS.EXHIBITOR_APPROVED]: "exhibitor_approved",
});

export const normalizeRegistrationStatus = (status) => {
  if (status === null || status === undefined || status === "") return "";
  const numeric = Number(status);
  if (Number.isInteger(numeric) && STATUS_KEY_BY_ID[numeric]) {
    return STATUS_KEY_BY_ID[numeric];
  }
  return String(status).trim().toLowerCase().replace(/[-\s]+/g, "_");
};

export const isShortlistedRegistrationStatus = (status) =>
  ["shortlist", "shortlisted", "approved", "joined", "exhibitor_approved"].includes(
    normalizeRegistrationStatus(status),
  );

export const isUnShortlistedRegistrationStatus = (status) =>
  ["un_shortlist", "un_shortlisted", "not_shortlisted", "rejected"].includes(
    normalizeRegistrationStatus(status),
  );

export const isPendingRegistrationStatus = (status) =>
  ["pending", "requested", "request", "exhibitor_pending", "exhibitor_in_review", "review_pending", "in_review"].includes(
    normalizeRegistrationStatus(status),
  );

export const isPendingPaymentStatus = (status) => {
  const normalized = String(status || "").trim().toUpperCase();
  return ["PENDING", "INITIATED", "PROCESSING", "IN_PROGRESS", "AWAITED"].includes(normalized);
};

export const registrationStatusLabel = (status) => {
  const key = normalizeRegistrationStatus(status);
  const labels = {
    pending: "Pending",
    shortlist: "Shortlisted",
    shortlisted: "Shortlisted",
    un_shortlist: "Un-shortlisted",
    un_shortlisted: "Un-shortlisted",
    exhibitor_pending: "Exhibitor Pending",
    exhibitor_in_review: "Exhibitor In Review",
    exhibitor_approved: "Exhibitor Approved",
    approved: "Approved",
    joined: "Joined",
    rejected: "Rejected",
    cancelled: "Cancelled",
    aborted: "Aborted",
  };
  if (labels[key]) return labels[key];
  return key ? key.replace(/_/g, " ").replace(/\b\w/g, (letter) => letter.toUpperCase()) : "Unknown";
};

export const REGISTRATION_STATUS_FILTER_OPTIONS = [
  { value: "shortlisted", label: "Shortlisted" },
  { value: "pending", label: "Pending" },
  { value: "un_shortlisted", label: "Un-shortlisted" },
  { value: "all", label: "All Statuses" },
];
